import { render, staticRenderFns } from "./FundedAthletesReport.vue?vue&type=template&id=061b906a"
import script from "./FundedAthletesReport.vue?vue&type=script&lang=js"
export * from "./FundedAthletesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports